import * as Roles from "@/constants/roles";
import { RouteConfig } from "vue-router";
import { LOYALTY_ROUTES } from "@/loyalty-routes";
import { DECLINED_TRANSACTIONS_ROUTES } from "./declined-transactions-routes";

export const ROUTE_NAMES = {
  APPLICATIONS: "application",
  APPLICATION_DETAIL: "application-detail",
  ACCESS_DENIED: "access-denied",
  PROMO_CODES: "promo-codes",
  PROMO_CODE_DETAIL: "promo-code-detail",
  STANDARD_OFFERS: "standard-offers",
  STANDARD_OFFER_DETAIL: "standard-offer-detail",
  REFERENCE_DATA: "reference-data",
  NOT_FOUND: "not-found"
};

export const routes: RouteConfig[] = [
  { path: "/", redirect: "/applications" },
  {
    name: ROUTE_NAMES.APPLICATIONS,
    path: "/applications",
    component: () =>
      import(/* webpackChunkName: "applications" */ "./views/Applications/Index.vue"),
    meta: {
      display: "OLA",
      parentName: ROUTE_NAMES.APPLICATIONS,
      submenu: ROUTE_NAMES.APPLICATIONS,
      label: "Applications",
      sortOrder: 1
    }
  },
  {
    name: ROUTE_NAMES.APPLICATION_DETAIL,
    path: "/applications/detail/:id?",
    component: () =>
      import(/* webpackChunkName: "applicationdetail" */ "./views/Applications/Detail.vue"),
    meta: {
      parentName: ROUTE_NAMES.APPLICATIONS,
      submenu: ROUTE_NAMES.APPLICATIONS,
    }
  },
  {
    name: ROUTE_NAMES.PROMO_CODES,
    path: "/promo-offers",
    component: () =>
      import(/* webpackChunkName: "promocodes" */ "./views/PromoCodes/Index.vue"),
    meta: {
      label: "Promo offers",
      requireRole: [Roles.PRICING_TEAM, Roles.SUPPORT, Roles.CREDIT, Roles.TELNET],
      parentName: ROUTE_NAMES.APPLICATIONS,
      submenu: ROUTE_NAMES.APPLICATIONS,
      sortOrder: 2
    }
  },
  {
    name: ROUTE_NAMES.PROMO_CODE_DETAIL,
    path: "/promo-offers/detail/:id?",
    props: true,
    component: () =>
      import(/* webpackChunkName: "promocodedetail" */ "./views/PromoCodes/Detail.vue"),
    meta: {
      requireRole: [Roles.PRICING_TEAM, Roles.SUPPORT, Roles.CREDIT, Roles.TELNET],
      parentName: ROUTE_NAMES.APPLICATIONS,
      submenu: ROUTE_NAMES.APPLICATIONS,
    }
  },
  {
    name: ROUTE_NAMES.STANDARD_OFFERS,
    path: "/standard-offers",
    component: () =>
      import(/* webpackChunkName: "offers" */ "./views/StandardOffers/Index.vue"),
    meta: {
      label: "Standard offers",
      requireRole: [Roles.PRICING_TEAM, Roles.SUPPORT, Roles.CREDIT, Roles.TELNET],
      parentName: ROUTE_NAMES.APPLICATIONS,
      submenu: ROUTE_NAMES.APPLICATIONS,
      sortOrder: 3
    }
  },
  {
    name: ROUTE_NAMES.STANDARD_OFFER_DETAIL,
    path: "/standard-offers/detail/:id?",
    props: true,
    component: () =>
      import(/* webpackChunkName: "offerdetail" */ "./views/StandardOffers/Detail.vue"),
    meta: {
      requireRole: [Roles.PRICING_TEAM, Roles.SUPPORT, Roles.CREDIT, Roles.TELNET],
      parentName: ROUTE_NAMES.APPLICATIONS,
      submenu: ROUTE_NAMES.APPLICATIONS,
    }
  },
  {
    name: ROUTE_NAMES.REFERENCE_DATA,
    path: "/reference-data",
    component: () =>
      import(/* webpackChunkName: "referencedata" */ "./views/ReferenceData/Index.vue"),
    meta: {
      label: "Reference data",
      requireRole: [Roles.PRICING_TEAM, Roles.SUPPORT],
      parentName: ROUTE_NAMES.APPLICATIONS,
      submenu: ROUTE_NAMES.APPLICATIONS,
      sortOrder: 4
    }
  },
  ...LOYALTY_ROUTES,
  ...DECLINED_TRANSACTIONS_ROUTES,
  {
    name: ROUTE_NAMES.ACCESS_DENIED,
    path: "/401",
    component: () =>
      import(/* webpackChunkName: "accessdenied" */ "./views/AccessDenied.vue")
  },
  {
    name: ROUTE_NAMES.NOT_FOUND,
    path: "/404",
    component: () => import("./views/NotFound.vue")
  },
  {
    path: "*",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "nf" */ "./views/NotFound.vue")
  }
];
